import { serviceUris } from './services';

export const environment = {
  analyticsId: 'G-DDWNJX2TG7',
  apiUrl: 'https://gateway-na-backend.btn.retread.michelingroup.com/',
  appHome: 'https://na.btn.retread.michelingroup.com/',
  authUrl: 'https://gateway-na-backend.btn.retread.michelingroup.com/',
  camServiceUrl: 'https://gateway-na-backend.btn.retread.michelingroup.com/',
  envName: 'na-prod',
  production: true,
  serviceUris,
  translationUrl: 'https://gateway-na-backend.btn.retread.michelingroup.com/',
  backOfficeUrl: 'https://gateway-na-backend.btn.retread.michelingroup.com/',
  labourOverheadServiceUrl: 'https://na.btn.retread.michelingroup.com/',
  version: 'r4.0.5.4',
  sha256Enable: false,
  tokenRefreshThreshold: 90 * 60 * 1000,
  notificationPollIntervalMs: 15 * 60 * 1000,
  bannerPollIntervalMs: 30 * 60 * 1000
};
